import { state } from '@angular/animations';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router
  ) {
  }


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let value = this.permissionLogic(state.url);
    return value;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let value = this.permissionLogic(state.url);
    return value;
  }

  permissionLogic(stateUrl) {
    let permissionExist = false;
    // remove third-party-software cond before merging
    const cleanUrl = stateUrl.split('?')[0].split('#')[0];
    if (stateUrl === '/add-value/payment-success' || cleanUrl === '/add-value/payment-error' || stateUrl === '/user-info' || stateUrl === '/third-party-software/add-edit') {
      permissionExist = true;
    }
    if (stateUrl === '/customers/create-customer') {
      let addEditPermissionArr = JSON.parse(localStorage.getItem('addEditPermissions'));
      let isPermission = addEditPermissionArr.filter(res => {
        return res.Enum === 38;
      });
      if (isPermission.length) {
        permissionExist = true;
      }
    } else {
      if ((stateUrl.includes('customerView') && (localStorage.getItem('DomainName') === 'admin' || JSON.parse(localStorage.getItem('IsPartner')))) || stateUrl.includes('customerDetails')) {
        permissionExist = true;
      }

      let navigationRoute = JSON.parse(localStorage.getItem('userNavigation'));
      navigationRoute?.forEach(route => {
        route?.children?.forEach(childRoute => {
          if (childRoute?.link === stateUrl) {
            permissionExist = true
          }
          childRoute?.children?.forEach(innerchildRoute => {
            if (innerchildRoute?.link === stateUrl) {
              permissionExist = true
            }
          })
        })
      });
    }
    if (!permissionExist) {
      this.router.navigate([localStorage.getItem('landingPage')]);
    }
    return permissionExist;
  }
}
